/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StatAggregateDataPoint
 */
export interface StatAggregateDataPoint {
    /**
     * RFC3339 timestamp
     * @type {Date}
     * @memberof StatAggregateDataPoint
     */
    datetime: Date;
    /**
     * 
     * @type {number}
     * @memberof StatAggregateDataPoint
     */
    count: number;
}

/**
 * Check if a given object implements the StatAggregateDataPoint interface.
 */
export function instanceOfStatAggregateDataPoint(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "datetime" in value;
    isInstance = isInstance && "count" in value;

    return isInstance;
}

export function StatAggregateDataPointFromJSON(json: any): StatAggregateDataPoint {
    return StatAggregateDataPointFromJSONTyped(json, false);
}

export function StatAggregateDataPointFromJSONTyped(json: any, ignoreDiscriminator: boolean): StatAggregateDataPoint {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'datetime': (new Date(json['datetime'])),
        'count': json['count'],
    };
}

export function StatAggregateDataPointToJSON(value?: StatAggregateDataPoint | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'datetime': (value.datetime.toISOString()),
        'count': value.count,
    };
}

